<template>
  <div>
    <transition name="filterOverlayFade">
      <div v-if="show" class="filterOverlay" @click="$emit('close')"></div>
    </transition>

    <transition name="filterDrawer">
      <div v-if="show" class="filterDrawerPanel" @click.stop>
        <div class="filterDrawerHeader">
          <div>
            <div class="filterTitle">{{ title }}</div>
            <div class="filterMeta">{{ countLabel }}</div>
          </div>
          <b-button size="sm" variant="outline-secondary" @click="$emit('close')">
            Fermer
          </b-button>
        </div>

        <div class="filterDrawerBody">
          <div v-if="hasSorts" class="filterSorts">
            <div class="sortTitle">Tri rapide</div>
            <div class="sortGrid">
              <slot name="sorts"></slot>
            </div>
          </div>

          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "FilterDrawerShell",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Filtres",
    },
    count: {
      type: Number,
      default: 0,
    },
    countSuffix: {
      type: String,
      default: "ligne(s) trouvées",
    },
  },
  computed: {
    hasSorts() {
      return Boolean(this.$slots.sorts);
    },
    countLabel() {
      return `${this.count} ${this.countSuffix}`;
    },
  },
};
</script>
